import { brands } from './brands.js';

const apiUrl = {
  LOCAL: import.meta.env.VITE_API_URL || 'https://ministrygrid.dev.lifeway.com',
  DEV: 'https://bethlehemapi.int.lifeway.com',
  STAGE: 'https://bethlehemapi.uat.lifeway.com',
  PROD: 'https://bethlehemapi.prod.lifeway.com',
};

const accountUrl = {
  LOCAL: import.meta.env.VITE_ACCOUNT_URL || 'https://account.int.lifeway.com',
  DEV: 'https://account.int.lifeway.com',
  STAGE: 'https://account.uat.lifeway.com',
  PROD: 'https://account.lifeway.com',
};

const gitHash = import.meta.env.VITE_GIT_HASH || 'LOCAL';
const devTheme = import.meta.env.VITE_DEV_THEME || '';

const SITE_WIDE_ORG_IDS = [
  '7eff9784-c290-44b4-9364-9961f3ca3859', // Lifeway
  'd0c6eb46-1784-49ae-960c-fc82e3e94dd2', // Lifeway Employees
  'fb782e99-b1d7-44df-bc18-206922301c8b', // Lifeway Kids
];

const config = {
  FEATURE_TOGGLES: {
    HYFI_PREVIEW: false,
    COPY_SESSION_TIMELINE: true,
    DEBUG_ANALYTICS: false,
    PODCAST_MATERIAL: true,
    EDITABLE_SESSION_TIMELINE: true,
    REACT_EVENT_STREAM: true,
    AOM_ORG_CREATION: true,
    AOM_ORG_CONNECTION: true,
    SWITCH_CURRICULUM_SUBSCRIPTION: true,
    ASSESSMENT_V2_REPORT: true,
  },

  CURRICULUM_PRICING_VERSION: 3,

  // TODO: Replace with value provider for each environment
  activeCampaignEnabled: window.location.host.includes('ministrygrid.lifeway.com'),
  logLevel: 'warn',

  BUZZSPROUT_API_KEY: import.meta.env.VITE_BUZZSPROUT_API_KEY || '',
  INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID || '',
  INTERCOM_AUTH_URL: import.meta.env.VITE_INTERCOM_AUTH_URL || '',
  GTM_APP_ID: import.meta.env.VITE_GTM_APP_ID || '',
  LIFEWAY_BASE_URL: import.meta.env.VITE_LIFEWAY_BASE_URL || 'https://int.lifeway.com/',
  MYLIFEWAY_BASE_URL: import.meta.env.VITE_MYLIFEWAY_BASE_URL || 'https://mlc.int.lifeway.com',
  MYLIFEWAY_CREATE_ACCOUNT_PATH: import.meta.env.VITE_MYLIFEWAY_CREATE_ACCOUNT_PATH || '/create-account/church',
};

const defaultBrand = brands.find(b => b.origin === 'GRID') ?? brands[0];

function resolveBrand() {
  const host = window.location.hostname.toLowerCase();

  // Local always uses grid.local.lifeway.com — theme comes from DEV_THEME at serve time.
  if (host.includes('local') && devTheme) {
    return brands.find(b => b.theme === devTheme) ?? defaultBrand;
  }

  // Prefer non-GRID matches so "ministrygrid" does not win over white-label hosts.
  const whiteLabel = brands.find(b => b.origin !== 'GRID' && b.hostIncludes && host.includes(b.hostIncludes));

  return whiteLabel ?? defaultBrand;
}

export const resolvedBrand = resolveBrand();

function envKeyFromHostname() {
  const host = window.location.hostname;
  if (host.includes('local')) return 'LOCAL';
  if (host.includes('dev')) return 'DEV';
  if (host.includes('stage')) return 'STAGE';
  return 'PROD';
}

window.addEventListener('unhandledrejection', function (event) {
  console.error('Unhandled promise rejection:', event.reason);
});

// FullStory reads its org id off window.config; only expose it for brands that opt in.
config.FULLSTORY_ORG_ID = resolvedBrand.isFullStoryEnabled ? import.meta.env.VITE_FULLSTORY_ORG_ID || '' : '';

window.config = config;

window.getSiteWideOrgIds = function () {
  return SITE_WIDE_ORG_IDS.slice();
};

window.getApiUrl = function () {
  const host = window.location.hostname;
  if (host.includes('local')) {
    // LOCAL API_URL is the gateway host; routes live under /api (same as deployed origin+/api).
    let base = String(apiUrl.LOCAL || '').replace(/\/$/, '');
    if (base && base.slice(-4) !== '/api') {
      base += '/api';
    }
    return base;
  }
  if (host.includes('bethlehem.stage')) {
    return 'https://ministrygrid.lifeway.com/api';
  }
  return window.location.origin + '/api';
};

window.getAccountUrl = function () {
  const host = window.location.hostname;
  if (host.includes('local')) {
    return accountUrl.LOCAL;
  }
  if (host.includes('dev')) {
    return accountUrl.DEV;
  }
  if (host.includes('bethlehem.stage')) {
    return accountUrl.PROD;
  }
  if (host.includes('stage')) {
    return accountUrl.STAGE;
  }
  return accountUrl.PROD;
};

window.getCommitHash = function () {
  return gitHash;
};

window.getOrigin = function () {
  return resolvedBrand.origin || 'GRID';
};

window.getWhiteLabelOrgId = function () {
  const orgIds = resolvedBrand.orgIds || {};
  return orgIds[envKeyFromHostname()];
};

window.getIsSSO = function () {
  return Boolean(resolvedBrand.isSSO);
};
